export const bucketConfig = {
  bucketName: "swtbucket",
  // dirName: "photo",
  region: "ap-south-1",
  accessKeyId: "AKIAW3MEA5EMAFDTQBVT",
  secretAccessKey: "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",
};
